import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Articulo } from 'src/app/Models/articulo/articulo';
import { Cliente } from 'src/app/Models/cliente/cliente';
import { DetalleFactura } from 'src/app/Models/factura/detallefactura/detalle-factura';
import { Factura } from 'src/app/Models/factura/factura';
import { Precio } from 'src/app/Models/precio/precio';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { ArticuloDialogComponent } from '../../articulo/articulo-dialog/articulo-dialog.component';
import { ClienteDialogComponent } from '../../cliente/cliente-dialog/cliente-dialog.component';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { PedidoDialogComponent } from '../pedido-dialog/pedido-dialog.component';
import { ClienteRegisterComponent } from '../../cliente/cliente-register/cliente-register.component';
import { Personal } from 'src/app/Models/personal/personal';
import { Title } from '@angular/platform-browser';
import * as moment from 'moment';
import { PrestamosComponent } from '../../prestamos/prestamos.component';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { Numero } from 'src/app/Models/numero/numero';
import { PrintPedidoComponent } from '../../print/print-pedido/print-pedido.component';
import { Subscription } from 'rxjs/internal/Subscription';
import { Subject, timer } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SetPrestamoComponent } from './set-prestamo/set-prestamo.component';

@Component({
  selector: 'app-pedido-index',
  templateUrl: './pedido-index.component.html',
  styleUrls: ['./pedido-index.component.css']
})
export class PedidoIndexComponent implements OnInit {
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild(ClienteDialogComponent, null) public fmclientedialog: ClienteDialogComponent;
  @ViewChild(ArticuloDialogComponent, null) public fmarticulodialog: ArticuloDialogComponent;
  @ViewChild(PedidoDialogComponent, null) public fmpedidodialog: PedidoDialogComponent;
  @ViewChild(ClienteRegisterComponent, null) public fmregcliente: ClienteRegisterComponent;
  @ViewChild(PrestamosComponent, null) public frmprestamos: PrestamosComponent;

  @ViewChild(PrintPedidoComponent, null) print_pedido: PrintPedidoComponent;

  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) artloading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  @ViewChild('txtdireccion', null) txtdireccion: ElementRef;
  public isShow: boolean = false;
  public pagina: number = 0;
  public pgpedido: any;
  public total: number = 0;
  public clientes: Cliente[] = [];
  public cliente: Cliente = new Cliente();
  public personal: Personal = new Personal();
  public isedit: Boolean = false;
  public articulo: Articulo = new Articulo();
  public precio: Precio = new Precio();
  public factura: Factura = new Factura();
  public detfactu: DetalleFactura = new DetalleFactura();
  public detfactus: DetalleFactura[] = [];
  detfactusOriginales: DetalleFactura[] = [];
  public usuario: any;

  //Nuevas variables
  public formapagos: any[] = [];
  public isEdit: boolean = false;
  public isfactura: boolean = false;
  public isdocvalid: boolean = false;
  public funcion: Function = null;
  public pagcli: any;
  public adddescripcion: boolean = false;
  public tipodocumento = '2'
  public modal = "modal-lg";
  public pagclidlg: any;
  public showdelete: boolean = false;
  public zindex: number = 10000;
  public isdisabled: boolean = true;
  public pagocontarjeta: boolean = false;
  public vuelto: number = 0;
  public alertType: AlertType = new AlertType;
  public serie_boleta: Numero = new Numero;
  public serie_factura: Numero = new Numero;
  public listapersonal: Personal[] = [];
  public tipos_balones: Articulo[] = [];
  public zonas: any[] = []
  public tipoprecios: any[] = []
  public tiposclientes: any[] = []
  public detallespago: any[] = [];
  public detallespagoOriginal: any[] = [];
  liquidacion: any = {};
  cantidad_invalida: boolean = false;

  pagocredito: boolean = false;
  nameResults: any[] = [];
  phoneResults: any[] = [];

  loadingName = false;
  loadingPhone = false;

  // Subjects para el debounce
  public nameSearchSubject = new Subject<string>();
  public phoneSearchSubject = new Subject<string>();

  articulos: any[] = [];            // resultados de búsqueda
  selectedArticulo: any = null;     // item seleccionado en ng-select
  itemsSeleccionados: any[] = [];   // lista que muestra la tabla
  loading: boolean = false;

  badgeCount = 0;
  private pollingSub: Subscription;
  private visibilityHandler: any;


  // para compatibilidad con tu método existente
  public search = {
    top: 100, clase: undefined, subclase: undefined, subgrupo: undefined, text: '',
    scale: 'ASC', marca: '', opcion: 'idprecio', codigo: '', nombre: '', idliquida: null, idvende: null
  };
  submitted = false;

  public usarPrecioAlterno: boolean = false;

  constructor(private title: Title, private data: DataService, private notify: NotifyService, private modalService: NgbModal, private auth: AuthService, private route: Router) {
    this.nameSearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(termino => {
      this.buscarNombres(termino);
    });

    // Configurar debounce para teléfono
    this.phoneSearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(termino => {
      this.buscarTelefonos(termino);
    });
  }

  ngOnInit() {
    this.title.setTitle('Ventas | Sistema de ventas');
    this.LoadPreData()

    this.getFormaPagos();
    this.GetZonasUbigeo();
    this.GetTiposCliente();
    this.GetTipoPrecios()
    this.getlistaPersonal();
    this.getTiposBalones();
    this.startPolling(10000);

    // opcional: pausar polling cuando la pestaña está oculta (ahorra recursos)
    this.visibilityHandler = () => {
      if (document.hidden) {
        console.log("Inactivo");

        this.stopPolling();
      } else {
        this.startPolling(10000);
      }
    };
    document.addEventListener('visibilitychange', this.visibilityHandler);

  }


  LoadPreData() {

    this.factura.valorvta = 0;
    this.factura.total = 0;
    this.factura.igvt = 0;
    this.factura.igv = 18.00;
    this.factura.tarjeta = '10'
    this.factura.fecha = moment(new Date()).format('YYYY-MM-DD')
    this.cliente.tipodocide = '1'
    this.usuario = this.auth.getCurrentUser();
    this.isedit = false;
    if (!(this.usuario.idpersonal.idnivel != 2)) {
      this.getliquidacion();
    } else {
      this.factura.idvende = 1
    }
    this.closeMetodoPago()
  }


  onNameSearch(event: { term: string }) {
    this.nameSearchSubject.next(event.term);  // Extrae el término del evento
  }

  // Cuando escribes en el input de teléfono
  onPhoneSearch(event: { term: string }) {
    this.phoneSearchSubject.next(event.term);  // Extrae el término del evento
  }

  // Buscar nombres en la API
  buscarNombres(termino: string) {
    if (!termino) {
      this.nameResults = [];
      return;
    }

    this.loadingName = true;
    const filtro = {
      search: termino
    }
    this.data.Post('search_clientes', filtro).subscribe({
      next: (data) => {
        this.nameResults = data.data;
        this.loadingName = false;
      },
      error: () => {
        this.loadingName = false;
        this.nameResults = [];
      }
    });
  }

  // Buscar teléfonos en la API
  buscarTelefonos(termino: string) {
    if (!termino) {
      this.phoneResults = [];
      return;
    }

    this.loadingPhone = true;
    const filtro = {
      search: termino
    }
    this.data.Post('search_clientes', filtro).subscribe({
      next: (data) => {
        this.phoneResults = data.data;
        this.loadingPhone = false;
      },
      error: () => {
        this.loadingPhone = false;
        this.phoneResults = [];
      }
    });
  }

  // Cuando seleccionas un nombre
  onSelectByName(clienteSeleccionado: any) {
    if (clienteSeleccionado) {

      if (clienteSeleccionado.idcliente) {
        console.log("Cliente seleccionado: ", clienteSeleccionado);

        this.cliente = { ...clienteSeleccionado };
        this.onTipoBalon({ target: { value: this.cliente.tipo_balon } });

      } else {
        this.cliente.nombre = clienteSeleccionado.nombre;
      }
    } else {
      this.cliente.nombre = '';
    }
  }

  // Cuando seleccionas un teléfono
  onSelectByPhone(clienteSeleccionado: any) {
    if (clienteSeleccionado) {
      if (clienteSeleccionado.idcliente) {
        this.cliente = { ...clienteSeleccionado };
        this.onTipoBalon({ target: { value: this.cliente.tipo_balon } });
      } else {
        this.cliente.telefono = clienteSeleccionado.telefono;
      }
    } else {
      this.cliente.telefono = '';
    }
  }

  getliquidacion() {
    if (this.usuario.idpersonal) {
      const datapersonal = { 'fecha': this.factura.fecha, 'idpersonal': this.usuario.idpersonal.idpersonal }
      console.log(datapersonal);

      this.data.Post('getLiqGasto', datapersonal).subscribe((data) => {
        // Manejar la respuesta exitosa
        this.factura.idvende = data.idpersonal
        this.liquidacion = data

        console.log('Liquidación obtenida:', data);
      },
        (error) => {
          // Manejar el error de obtener la liquidación
          console.error('Error al obtener la liquidación:', error);
          this.data.notify("Solicite una liquidacion.", 'Error al obtener la liquidación', this.data.alertType.error)
          // Si no se puede obtener la liquidación, cerrar sesión y redirigir a la página de inicio de sesión
          this.auth.logoutUser();
        }
      );
    } else {
      this.data.notify("Solicite una liquidacion.", 'Error al obtener la liquidación', this.data.alertType.error)
      this.auth.logoutUser();
    }

  }


  async show_pedido_dialog() {
    this.fmpedidodialog.pedido = undefined;
    this.fmpedidodialog.datadia = false
    await new Promise((resolve) => {
      this.fmpedidodialog.show(() => {
        resolve(true); // Esto se ejecuta cuando se cierra
      });
    });
    if (this.fmpedidodialog.pedido && this.fmpedidodialog.pedido.idfactura) {
      this.isedit = true;
      const factu = await this.data.AsyncGetFromId(this.data.api.factura, this.fmpedidodialog.pedido.idfactura.toString())
      let detalles = []
      let detpagos = []
      if (factu.idfactura) {
        detalles = await this.data.AsyncGetFromValue(this.data.api.detfactura, 'idfactura', this.fmpedidodialog.pedido.idfactura)
        detpagos = await this.data.AsyncGetFromValue('detpago', 'idfactura', this.fmpedidodialog.pedido.idfactura)
      }
      console.log("factura y detalles", factu, detalles);
      if (factu.idfactura && detalles.length > 0) {
        this.factura = {
          ...factu,
          idvende: factu.idvende ? (factu.idvende as any).idpersonal : null,
          idcliente: factu.idcliente ? (factu.idcliente as any).idcliente : null,
          idsucursal: factu.idsucursal ? (factu.idsucursal as any).idsucursal : null,
        }
        this.factura.fec_entrega = moment(new Date()).format('YYYY-MM-DDTHH:MM')
        if (detpagos && detpagos.length > 0) {
          this.pagocontarjeta = true;
          this.detallespago = detpagos.map(d => ({
            ...d,
            idfactura: d.idfactura ? (d.idfactura as any).idfactura : null,
          }));

          this.detallespagoOriginal = [...this.detallespago];
        }
        this.cliente = factu.idcliente ? { ...(factu.idcliente as any) } : new Cliente();
        this.detfactus = detalles.map(d => ({
          ...d,
          idfactura: d.idfactura ? (d.idfactura as any).idfactura : null,
          articulo: d.idproduct ? (d.idproduct as any) : new Articulo(),
          idzona: d.idzona ? (d.idzona as any).idzona : null,
          precio: d.idzona ? (d.idzona as any) : new Precio(),
          idproduct: d.idproduct ? (d.idproduct as any).idproduct : null,
        }))
        this.detfactusOriginales = [...this.detfactus];
      }
    } else {
      this.LoadPreData()
      return
    }
  }

  reset() {
    this.factura = new Factura();
    this.articulo = new Articulo();
    this.cliente = new Cliente();
    this.detfactus = [];
    this.LoadPreData()
  }

  ShowPrestamos() {
    this.frmprestamos.detfactus = []
    this.frmprestamos.show(() => { });
  }

  valida_tiporuc() {
    this.factura.documen = "PED";
  }


  async SetPrestamo(item: DetalleFactura) {
    item.saldo = item.ingreso;
    item.ingreso = 0;
    item.isprestamo = true;

    return item;

  }

  ShowDialogPedidosDia() {
    this.fmpedidodialog.pedido = undefined;
    this.fmpedidodialog.datadia = true
    this.fmpedidodialog.titulo = "Pedidos del dia"
    this.fmpedidodialog.show(async () => {
      if (this.fmpedidodialog.pedido != undefined) {

      } else { this.isedit = false; }
    });
  }

  calcula_total() {
    this.factura.total = 0;
    let gravado: number = 0.00;
    let exonerado: number = 0.00;
    let inafecto: number = 0.00;
    let igvt: number = 0.00;


    for (let det of this.detfactus) {
      if (parseInt(det.afectoigv) > 0 && parseInt(det.afectoigv) < 8) {

        gravado += parseFloat(det.impneto);
      }
      else if (parseInt(det.afectoigv) == 8) {
        exonerado += parseFloat(det.impneto);
      }
      else if (parseInt(det.afectoigv) > 8 && parseInt(det.afectoigv) < 17) {
        inafecto += parseFloat(det.impneto);
      } else {
        console.log('valor inafecto invalido');
      }

      igvt += parseFloat(det.igvi);
    }

    this.factura.valorvta = +gravado.toFixed(2);
    this.factura.impnogrv = +exonerado.toFixed(2);
    this.factura.impinafec = +inafecto.toFixed(2);
    this.factura.igvt = +igvt.toFixed(2);
    this.factura.total = +(gravado + exonerado + inafecto + igvt).toFixed(2)
    this.actualizar_registro()
    this.validarSaldo()
  }

  /*calcula el detalle de acuerdo al tipo afecto igv */
  calcula_detalle(det: DetalleFactura): DetalleFactura {
    let tasa_igv = 1;
    det.igv = "0.00";
    det.descuento = "0.00";
    tasa_igv = 1.18;
    det.igv = "18.00";
    det.ingreso = parseInt(det.cantidad);
    det.valorunit = (parseFloat(det.preuni) / tasa_igv).toFixed(6);

    det.impneto = (parseFloat(det.valorunit) * parseFloat(det.cantidad)).toFixed(2);
    det.impnetoct = (parseFloat(det.cantidad) * parseFloat(det.preuni)).toFixed(2);
    det.igvi = (parseFloat(det.impnetoct) - parseFloat(det.impneto)).toFixed(2);
    if (det.isprestamo) {
      this.SetPrestamo(det);
    }
    console.log(det);

    var saldo: number = this.GetSaldo(det);
    console.log("Cantidad: ", Number(det.cantidad));
    console.log("Cumple la condicion?: ", (Number(det.cantidad) > saldo));

    det.esCantidadInvalida = (Number(det.cantidad) > saldo);
    return det;
  }

  CalculaStock(det: DetalleFactura): number {
    let saldo = (det.articulo.atributo == '1' ? det.articulo.saldo00002 : det.articulo.saldo00001);
    let a = ((parseFloat(saldo) * parseFloat(det.precio.idproduct.unidad.equivale)) / parseFloat(det.precio.unidad.equivale)) - parseFloat(det.cantidad);
    return a;
  }
  CalculaStockBase(det: DetalleFactura): number {
    let saldo = (det.articulo.atributo == '1' ? det.articulo.saldo00002 : det.articulo.saldo00001);
    let a = (parseFloat(saldo) * parseFloat(det.precio.idproduct.unidad.equivale)) / parseFloat(det.precio.unidad.equivale);
    return a;
  }
  IsStock(det: DetalleFactura): boolean {
    let stock = this.CalculaStock(det);
    console.log(parseFloat(stock + ""));
    console.log((parseFloat(stock + "") / parseFloat(det.precio.unidad.equivale)));
    if (stock > 0) {
      if (parseFloat(stock + "") >= (parseFloat(stock + "") / parseFloat(det.precio.unidad.equivale))) {
        return true;
      } else { return false; }
    } else { return false; }

  }
  precio_change_cantidad(i) {
    let det: DetalleFactura = this.detfactus[i];

    this.calcula_detalle(det);
    this.calcula_total();
  }
  precio_change_precio(i) {
    let det: DetalleFactura = this.detfactus[i];
    this.calcula_detalle(det);
    this.calcula_total();
  }

  reimprimir() {
    this.show_ticket(this.factura.idfactura);
  }

  //Codigo no factorizado
  validateFields(): boolean {
    return this.cliente.documento && this.cliente.tipodocide && this.factura.direccion !== null;
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.validateFields()) {
      console.log('Form Submitted!', this.factura);
    }
  }

  getFormaPagos() {
    this.data.GetSimple(this.data.api.mediopago).subscribe(r => {
      this.formapagos = r.filter(x => x.codigo !== "10");
    });
  }

  getlistaPersonal() {
    this.data.GetSimple(this.data.api.personal).subscribe((r) => {
      this.listapersonal = r
    })
  }

  getTiposBalones() {
    this.data.GetSimple('tipos_balones').subscribe((r) => {
      this.tipos_balones = r.data
      console.log('Tipos balones: ', r);
    })
  }

  getliquidacionRegistro() {

    const datapersonal = { 'fecha': this.factura.fecha, 'idpersonal': this.factura.idvende }
    console.log(datapersonal);

    this.data.Post('getLiqGasto', datapersonal).subscribe((data) => {
      // Manejar la respuesta exitosa
      console.log('Liquidación obtenida:', data);
    },
      (error) => {
        // Manejar el error de obtener la liquidación
        console.error('Error al obtener la liquidación:', error);
        // Si no se puede obtener la liquidación, cerrar sesión y redirigir a la página de inicio de sesión
        this.usuario.idpersonal.idnivel != 2 ? this.data.notify("Se necesita crear una liquidacion.", "Liquidacion no encontrada.", this.data.alertType.info) : this.auth.logoutUser()
      }
    );

  }

  GetZonasUbigeo() {
    this.data.GetSimple(this.data.api.ubicacion).subscribe(r => {

      this.zonas = r;
      console.log(this.zonas);
    });
  }

  GetTiposCliente() {
    this.data.GetSimple("tipocliente").subscribe(r => {

      this.tiposclientes = r;
    })
  }

  GetTipoPrecios() {
    this.data.GetSimple(this.data.api.zona).subscribe(
      (res) => {
        console.log("zonas", res);

        this.tipoprecios = res;
      },
      (error) => { console.log(error) }
    );
  }

  actualizar_registro() {
    console.log("Actualizando total a: ", this.factura.total);

    if (!this.pagocontarjeta) {
      // Modo efectivo puro
      this.factura.efectivo = this.factura.total;
      this.factura.recibido = this.factura.efectivo;
      this.factura.vuelto = 0;
      this.factura.tarjetachq = 0;
    } else {
      // Modo mixto: recalcular el efectivo basado en el nuevo total
      // Los métodos de pago mantienen sus valores, el efectivo se ajusta
      this.calcularEfectivo();
    }

    this.factura.fec_entrega = moment(new Date()).format('YYYY-MM-DDTHH:mm');
  }

  async GetCliente1() {
    console.log("buscando cliente");
    await this.data.AsyncGetFromValue(this.data.api.cliente, 'documento', this.cliente.documento).then(async r => {
      console.log(r);

      if (r.length < 1) {
        console.log("buscando en sunat");
        await this.data.Consulta('ruc', this.cliente.documento).then(r => {
          console.log(r);
          if (r.result == 1) {
            //this.personal.nombre = r.nombres + ' ' + r.apellidoPaterno + ' ' + r.apellidoMaterno
            this.cliente.nombre = r.message.razon_social
            this.cliente.tipodocide = '1'
          } else {
            this.data.notify("Cliente no encontrado, ingrese uno manualmente.", "Error", this.alertType.error);
          }
        }).catch(() => { this.data.notify("DNI invalido o no existente", 'Error', this.data.alertType.error) })

      } else {
        console.log(r);
        const objcliente = r[0]
        this.cliente = {
          ...objcliente,
          zona_ubigeo: objcliente.zona_ubigeo ? objcliente.zona_ubigeo.idubicacion : null,
          tipo_cliente: objcliente.tipo_cliente ? objcliente.tipo_cliente.id : null
        }
        this.onTipoBalon({ target: { value: this.cliente.tipo_balon } });

        console.log("Tipo documento del cliente");
        console.log(this.cliente.tipodocide);
      }
    }, e => {
      console.log(e);
    })
  }

  async GetCliente() {
    console.log("buscando cliente");

    // ✅ PASO 1: Buscar en la base de datos local primero
    await this.data.AsyncGetFromValue(this.data.api.cliente, 'documento', this.cliente.documento).then(async r => {
      console.log("Resultado de búsqueda en BD:", r);

      if (r.length > 0) {
        // ✅ CLIENTE EXISTENTE ENCONTRADO - Autocompletar TODO
        console.log("Cliente encontrado en BD:", r[0]);

        const objcliente = r[0];

        // Copiar TODOS los datos del cliente
        this.cliente = {
          ...objcliente,
          zona_ubigeo: objcliente.zona_ubigeo ? objcliente.zona_ubigeo.idubicacion : null,
          tipo_cliente: objcliente.tipo_cliente ? objcliente.tipo_cliente.id : null,
          tipo_balon: objcliente.tipo_balon || null
        };

        console.log("Cliente autocompletado:", this.cliente);

        // ✅ Filtrar productos según el tipo de balón guardado
        if (this.cliente.tipo_balon) {
          this.onTipoBalon({ target: { value: this.cliente.tipo_balon } });
        }

        // ✅ Opcional: Cargar último producto pedido
        await this.cargarUltimoProductoPedido(this.cliente.idcliente);

        // Notificar al usuario
        this.data.notify(
          `Cliente "${this.cliente.nombre}" encontrado. Datos autocompletados.`,
          "Cliente Encontrado",
          this.alertType.success
        );

      } else {
        // ❌ CLIENTE NO EXISTE - Buscar en SUNAT/RENIEC
        console.log("Cliente no encontrado, buscando en SUNAT/RENIEC");

        await this.data.Consulta('ruc', this.cliente.documento).then(r => {
          console.log("Respuesta de SUNAT/RENIEC:", r);

          if (r.result == 1) {
            // Datos de SUNAT/RENIEC (cliente nuevo)
            this.cliente.nombre = r.message.razon_social;
            this.cliente.tipodocide = '1';

            this.data.notify(
              "Cliente nuevo desde RENIEC/SUNAT. Complete los datos adicionales.",
              "Cliente Nuevo",
              this.alertType.info
            );
          } else {
            this.data.notify(
              "Cliente no encontrado en RENIEC/SUNAT. Ingrese manualmente.",
              "No Encontrado",
              this.alertType.warning
            );
          }
        }).catch(() => {
          this.data.notify(
            "DNI/RUC inválido o servicio no disponible.",
            'Error',
            this.data.alertType.error
          );
        });
      }
    }, e => {
      console.error("Error en búsqueda de cliente:", e);
      this.data.notify(
        "Error al buscar cliente.",
        'Error',
        this.data.alertType.error
      );
    });
  }

  async cargarUltimoProductoPedido(idcliente: string) {
    try {
      // Endpoint que debes crear en el backend:
      // devuelve el último detfactu de este cliente ordenado por fecha descendente
      const resultado = await this.data.AsyncPost('get_ultimo_producto_cliente', { idcliente });

      if (resultado && resultado.data && resultado.data.length > 0) {
        const ultimoProducto = resultado.data[0];

        console.log("Último producto pedido:", ultimoProducto);

        // Mostrar sugerencia al usuario (opcional)
        this.data.notify(
          `Última compra: ${ultimoProducto.idproduct.nombre} (${ultimoProducto.cantidad} unidades)`,
          "Historial",
          this.alertType.info
        );

        // Opcional: Pre-agregar el producto a la lista
        // this.selectedArticulo = ultimoProducto.precio;
        // this.ShowDialogArticulo();
      }
    } catch (error) {
      console.log("No se pudo cargar último producto:", error);
      // No es crítico, continuar normalmente
    }
  }

  close() {
    this.btnclose.nativeElement.click();
    setTimeout(() => { this.isShow = false; }, 1000);
    setTimeout(() => { if (this.funcion != null) { this.funcion(); } }, 10);
  }

  ValidarTipoDoc() {
    this.cliente.documento = null;
    this.cliente.nombre = null;
    this.tipodocumento != "1" ? this.isfactura = false : this.isfactura = true;

  }

  // calcularEfectivo() {
  //     this.factura.efectivo = this.factura.total - this.factura.tarjetachq
  // }

  buscarDireccion() {
    const direccion = (document.getElementById('direccion') as HTMLInputElement).value;
    const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(direccion)}`;
    window.open(url, '_blank');
  }

  ValidarDocumento() {
    var ExpReg = '^[0-9]{11}$';
    let error = "RUC debe contener 11 digitos."

    if (this.tipodocumento == "1") {
      if (this.cliente.documento.match(ExpReg) != null) {
        console.log("exito");
        this.isdocvalid = true;
      } else {
        this.alert.show(error, 0, 5000)
        this.isdocvalid = false;
        console.log(error);
      }
    } else {
      if (this.cliente.documento != undefined) {
        this.isdocvalid = true;
      } else { this.isdocvalid = false; }
    }
  }

  isDocValid() {
    return this.isdocvalid
  }

  addMetodoPago() {
    if (!this.pagocontarjeta) {
      // Primera vez que agrega tarjeta
      this.pagocontarjeta = true;

      // Tomar el valor que estaba en efectivo y pasarlo al primer método de pago
      const montoInicial = this.factura.efectivo || this.factura.total;

      this.agregarDetPago({
        codigo: '',
        importe: montoInicial
      });
    } else {
      // Ya hay tarjetas, agregar con el restante
      const restante = this.calcularRestante();

      this.agregarDetPago({
        codigo: '',
        importe: restante > 0 ? restante : 0
      });
    }

    // Calcular el efectivo basado en los métodos de pago
    this.calcularEfectivo();
  }


  closeMetodoPago() {
    this.pagocontarjeta = false;
    this.factura.tarjeta = '10'
    if (this.factura.tarjetachq != 0) {
      this.factura.efectivo = this.factura.total
    }
    this.detallespago = [];
    this.calcularEfectivo();
  }

  agregarDetPago(data: any = null) {
    console.log("Recibiendo data: ", data);

    this.detallespago.push({
      codigo: data.codigo || '',
      importe: data ? parseFloat((+data.importe || 0).toFixed(2)) : 0,
      numopera: '',
      idfactura: data.idfactura || null
    });
  }

  // Eliminar una fila específica
  eliminarDetPago(index: number) {
    this.detallespago.splice(index, 1);

    // Si no quedan métodos de pago, volver a modo solo efectivo
    if (this.detallespago.length === 0) {
      this.pagocontarjeta = false;
      this.factura.efectivo = parseFloat(this.factura.total.toFixed(2));
      this.factura.tarjetachq = 0;
    } else {
      this.calcularEfectivo();
    }
  }

  // Calcular el total de tarjetas/otros medios
  calcularTotalTarjetas(): number {
    let total = 0;
    if (this.detallespago && this.detallespago.length > 0) {
      this.detallespago.forEach(pago => {
        total += parseFloat(pago.importe) || 0;
      });
    }
    return parseFloat(total.toFixed(2));
  }

  validarImporte(pago: any, index: number) {
    const importeActual = parseFloat(pago.importe) || 0;

    // Calcular cuánto se ha pagado SIN contar este pago
    let totalOtrosPagos = 0;
    this.detallespago.forEach((p, i) => {
      if (i !== index) {
        totalOtrosPagos += parseFloat(p.importe) || 0;
      }
    });

    // El máximo que puede ingresar es lo que falta por pagar
    const maximoPermitido = parseFloat((this.factura.total - totalOtrosPagos).toFixed(2));

    // Si supera el máximo, ajustar al máximo permitido
    if (importeActual > maximoPermitido) {
      pago.importe = maximoPermitido;
      // alert(`El importe no puede superar ${maximoPermitido.toFixed(2)}`);
    }

    this.calcularEfectivo();
  }

  // Método para formatear el importe cuando el usuario pierde el foco del input
  formatearImporte(pago: any, index: number) {
    if (pago.importe) {
      pago.importe = parseFloat(parseFloat(pago.importe).toFixed(2));
    }
    this.validarImporte(pago, index);
  }

  // Calcular cuánto se paga en efectivo
  calcularEfectivo() {
    if (this.pagocontarjeta) {
      // Sumar todos los pagos con tarjeta
      this.factura.tarjetachq = this.calcularTotalTarjetas();

      // El efectivo es lo que falta para completar el total
      this.factura.efectivo = parseFloat((this.factura.total - this.factura.tarjetachq).toFixed(2));

      // Si las tarjetas cubren todo o más, efectivo = 0
      if (this.factura.efectivo < 0) {
        this.factura.efectivo = 0;
      }

      // Resetear vuelto cuando hay tarjetas
      this.factura.vuelto = 0;
      this.factura.recibido = 0;
    } else {
      // Modo solo efectivo
      this.factura.tarjetachq = 0;
      this.factura.efectivo = parseFloat(this.factura.total.toFixed(2));
    }
  }

  // Calcular vuelto (solo cuando NO hay tarjetas)
  CalcularVuelto() {
    const inputVuelto = document.getElementById("inp_vuelto");

    if (inputVuelto) {
      inputVuelto.setAttribute("style", "border: 1px solid red;");
    }

    if (!this.pagocontarjeta && this.factura.recibido > this.factura.efectivo && this.factura.efectivo != 0) {
      this.factura.vuelto = parseFloat((this.factura.recibido - this.factura.efectivo).toFixed(2));

      if (inputVuelto) {
        inputVuelto.setAttribute("style", "");
      }
    }
  }

  // Método auxiliar para mostrar cuánto falta por pagar
  calcularRestante(): number {
    console.log("Monto efectivo: ", typeof this.factura.efectivo);
    console.log("Monto tarjetas: ", typeof this.factura.tarjetachq);

    const totalPagado = parseFloat((+this.factura.efectivo + this.factura.tarjetachq).toFixed(2));

    return parseFloat((this.factura.total - totalPagado).toFixed(2));
  }

  getAbsRestante(): number {
    return parseFloat(Math.abs(this.calcularRestante()).toFixed(2));
  }

  isCliente() {
    if (this.pagocontarjeta == false) {
      let res = this.cliente.nombre != undefined && this.cliente.documento != undefined && this.cliente.tipodocide != undefined && this.cliente.direccion != undefined
        && this.factura.total != 0 && this.factura.efectivo != 0 && this.factura.recibido != 0 && this.factura.vuelto != undefined
      return res

    } else {
      return this.cliente.nombre != undefined && this.cliente.documento != undefined && this.cliente.tipodocide != undefined && this.cliente.direccion != undefined
        && this.factura.total != 0 && this.factura.tarjeta != undefined && this.factura.tarjetachq != 0 && this.factura.voucher != undefined
    }

  }

  async prepara_data() {

    this.factura.apellidos = this.cliente.apellidos;

    this.factura.ruc = this.cliente.ruc;
    this.factura.moneda = this.precio ? this.precio.moneda.codigo : "PEN";
    this.factura.idcliente = this.cliente.idcliente;
    this.factura.apellidos = this.cliente.nombre;
    this.factura.direccion = this.cliente.direccion;
    this.factura.ruc = this.cliente.documento;
    this.factura.tip_iden = this.cliente.tipodocide;
    this.usuario.idpersonal.idnivel != 2 ? this.factura.entrega = 0 : this.factura.entrega = 1

    console.log("Personal actual: ", this.usuario.idpersonal.idpersonal);
    console.log("Personal de la factura: ", this.factura.idvende);

    if (this.usuario.idpersonal.idnivel != 2 && (this.usuario.idpersonal.idpersonal == this.factura.idvende)) {
      this.factura.entrega = 1
    }
    this.ispagocredito();
    // debugger
    // if (this.factura.tarjeta === '13') {
    //     this.factura.estado = 'EMI'

    // } else {
    //     this.factura.estado = 'CAN'
    //     this.factura.fvcto = null
    //     this.factura.diasletras = null
    // }
    this.validarSaldo()
    this.factura.clasepago = 'CON'
    console.log("preparando factura");
    console.log(this.factura);
    console.log(this.factura.ruc);


  }

  async ActualizarCliente() {
    console.log("Actualizando cliente");
    await this.data.AsyncPut(this.data.api.cliente, this.cliente.idcliente, this.cliente).then(async r => {
      console.log(r);
    }, e => {
      console.log(e);
    })
  }

  async getPersonal() {
    await this.data.AsyncGetFromValue(this.data.api.personal, 'idusuario', this.usuario.id).then(r => {
      console.log(r);
      this.personal = r[0];
      console.log("Obteniendo personal", this.personal);
    });
  }

  async GuardarDetFactu() {
    this.detfactus.forEach(async detfactura => {
      await this.data.AsyncPost(this.data.api.detfactura, detfactura).then(async (r) => {
        if (r.length > 0) {
          console.log("detalles guardados");
        }
      }).catch(async (e) => { console.log(e); this.info.show(e, 0); });

    });

  }

  async show_ticket(idfactura: any) {
    switch (this.tipodocumento) {
      case '0':
        this.route.navigateByUrl('/printer/boleta/' + idfactura);
        break;
      case '1':
        this.route.navigateByUrl('/printer/factura/' + idfactura);
        break;
      case '2':
        try {

          // this.print_pedido.detalle = [];
          this.print_pedido.facturaId = idfactura;
          await this.print_pedido.getEmpresa()
          await this.print_pedido.getFactura(); // Espera a que termine
          setTimeout(() => {
            this.print_pedido.generarTicket();
            this.reset()
            this.artloading.hide();
          }, 500);

        } catch (error) {
          console.error("Error en el flujo:", error);
        }
        break;
      default:
        break;
    }


  }


  async GuardarNumero(idnumero: any, numero: Numero) {
    numero.ultimo = (+numero.ultimo + 1)
    await this.data.AsyncPut(this.data.api.numero, idnumero, numero).then(r => {
      if (r.status != "success") {
        console.log("Ejecutando GuardarNumero");
        console.log(r);
      }
    }).catch(e => console.log(e))
  }

  async GuardarFactura() {

    //this.factura.idsucursal = 1
    this.factura.idsucursal = parseInt(this.data.getSucursalId())
    switch (this.tipodocumento) {
      case '0':
        this.factura.documen = 'BOL'
        this.factura.serie = this.serie_boleta.serie
        // this.factura.numero = (+this.serie_boleta.ultimo + 1)
        // await this.GuardarNumero(this.serie_boleta.idnumero, this.serie_boleta)
        break;
      case '1':
        this.factura.documen = 'FAC'
        this.factura.serie = this.serie_factura.serie
        // this.factura.numero = (+this.serie_factura.ultimo + 1)
        // await this.GuardarNumero(this.serie_factura.idnumero, this.serie_factura)
        break;
      case '2':
        this.factura.documen = 'PED'
        const seriepedido = await this.data.GetSeriePedido() as Numero
        console.log("Obteniendo series:", seriepedido);
        this.factura.serie = seriepedido.serie
        // this.factura.numero = seriepedido.ultimo
        // await this.GuardarNumero(seriepedido.idnumero, seriepedido)
        break;
      default:
        break;
    }

    if (this.detfactus.length < 1) {
      this.data.notify("No hay productos en la lista.", 'Error', 0);
    } else {
      let idfactu: any = ''
      await this.data.AsyncPost(this.data.api.factura, this.factura).then(async (r) => {
        if (r.idfactura != null && r.idfactura != undefined) {
          if (r.idfactura != undefined) {
            idfactu = r.idfactura
            /* registrar detalle */
            let item: number = 1;
            for (let det of this.detfactus) {
              det.idfactura = r.idfactura;
              console.log(det.idfactura);
              console.log(det);

              // det.item = item+"";
              await this.data.AsyncPost(this.data.api.detfactura, det).then(x => {

                console.log(x);
              }).catch(e => { console.log(e); })
            }

            this.detallespago.forEach(det => {
              det.idfactura = r.idfactura;
              this.data.AsyncPost('detpago', det).then(x => {
                console.log(x);
              }).catch(e => { console.log(e); })
            });

          } else {
            this.data.notify("error", 'Error de registro', 0);
          }
        } else {
          console.log(r);
        }
      }).catch(e => {
        console.log(e);
        this.info.show(e, 0)
        this.data.notify("Error al guardar la factura.", this.data.alertType.error);
        this.artloading.hide();

      }).finally(() => {

        this.show_ticket(idfactu)
      })
    }

  }

  async ActualizarFactura() {


    if (this.detfactus.length < 1) {
      this.data.notify("No hay productos en la lista.", 'Error', 0);
    } else {
      this.factura.entrega = 1
      await this.data.AsyncPut(this.data.api.factura, this.factura.idfactura.toString(), this.factura).then(async (r) => {
        if (r.status == 'success') {
          const nuevos = this.detfactus.filter(det => !det.id_det);

          // Actualizados: los que SÍ tienen id_det y están en detfactus actuales
          const actualizados = this.detfactus.filter(det => det.id_det);

          // Eliminados: los que están en originales pero NO en actuales
          const idsActuales = this.detfactus.map(det => det.id_det).filter(id => id);
          const eliminados = this.detfactusOriginales.filter(det => !idsActuales.includes(det.id_det));

          console.log('Nuevos:', nuevos);
          console.log('Actualizados:', actualizados);
          console.log('Eliminados:', eliminados);

          // 2. ELIMINAR
          for (let det of eliminados) {
            await this.data.AsyncDelete(this.data.api.detfactura, det.id_det)
              .then(x => console.log('Eliminado:', x))
              .catch(e => console.log('Error eliminando:', e));
          }

          // 3. ACTUALIZAR
          for (let det of actualizados) {
            det.idfactura = this.factura.idfactura.toString();
            await this.data.AsyncPut(this.data.api.detfactura, det.id_det, det)
              .then(x => console.log('Actualizado:', x))
              .catch(e => console.log('Error actualizando:', e));
          }

          // 4. CREAR NUEVOS
          for (let det of nuevos) {
            det.idfactura = this.factura.idfactura.toString();
            await this.data.AsyncPost(this.data.api.detfactura, det)
              .then(x => console.log('Creado:', x))
              .catch(e => console.log('Error creando:', e));
          }

          const nuevosPagos = this.detallespago.filter(det => !det.id);
          const actualizadosPagos = this.detallespago.filter(det => det.id);
          const idsActualesPagos = this.detallespago.map(det => det.id).filter(id => id);
          const eliminadosPagos = this.detallespagoOriginal.filter(det => !idsActualesPagos.includes(det.id));

          console.log('Pagos Nuevos:', nuevosPagos);
          console.log('Pagos Actualizados:', actualizadosPagos);
          console.log('Pagos Eliminados:', eliminadosPagos);

          // ELIMINAR PAGOS
          for (let det of eliminadosPagos) {
            await this.data.AsyncDelete('detpago', det.id)
              .then(x => console.log('Pago Eliminado:', x))
              .catch(e => console.log('Error eliminando pago:', e));
          }

          // ACTUALIZAR PAGOS
          for (let det of actualizadosPagos) {
            det.idfactura = this.factura.idfactura.toString();
            await this.data.AsyncPut('detpago', det.id, det)
              .then(x => console.log('Pago Actualizado:', x))
              .catch(e => console.log('Error actualizando pago:', e));
          }

          // CREAR NUEVOS PAGOS
          for (let det of nuevosPagos) {
            det.idfactura = this.factura.idfactura.toString();
            await this.data.AsyncPost('detpago', det)
              .then(x => console.log('Pago Creado:', x))
              .catch(e => console.log('Error creando pago:', e));
          }


        } else {
          this.data.notify("error", 'Error de registro', 0);
        }
      }).catch(e => { console.log(e); this.info.show(e, 0) }).finally(() => {

        this.show_ticket(this.factura.idfactura)
      })
    }

  }

  async Save() {
    if (!this.factura.idvende) {
      this.data.notify("No hay vendedor asignado", "Error", this.data.alertType.error)
      return

    }
    await this.prepara_data().then(async () => {
      let idcliente = this.cliente.idcliente
      this.artloading.show('Guardando datos');

      if (idcliente != null && idcliente != undefined && idcliente != '') {
        console.log("guardando factura");
        this.GuardarFactura();
        this.ActualizarCliente();
      } else {
        await this.data.AsyncPost(this.data.api.cliente, this.cliente).then(async (r) => {
          try {
            if (r.idcliente) {
              this.cliente = r;
              this.factura.idcliente = this.cliente.idcliente
            }
          } catch (error) {
            console.log(error);

          }
        }).then(r => { this.GuardarFactura() }).catch(e => { console.log(e) })
      }
    });

  }

  async Edit() {
    if (!this.factura.idvende) {
      this.data.notify("No hay vendedor asignado", "Error", this.data.alertType.error)
      return

    }
    await this.prepara_data().then(async () => {
      let idcliente = this.cliente.idcliente
      this.artloading.show('Guardando datos');

      this.ActualizarFactura();
    });

  }

  onSearchArticulos(term: string) {
    // opcional: filtrar si term es muy corto
    if (!term || term.length < 2) {
      this.articulos = [];
      return;
    }
    this.search.nombre = term;
    this.search_articulos();
  }

  search_articulos() {
    this.loading = true;
    console.log("Enviando busqueda : ", this.search);

    let ruta = 'search_precios'

    if (this.usuario.idpersonal.idnivel == 2) {
      ruta = 'search_productos_vendedor'
      this.search.idliquida = this.liquidacion.idliquida
      this.search.idvende = this.usuario.idpersonal.idpersonal
    }

    this.data.Post(ruta, this.search).subscribe(r => {
      console.log("Data obtenida cruda: ", r);

      this.loading = false;
      if (!r || r.message !== "success") {
        console.log('Error search_precios', r);
        this.articulos = [];
      } else {
        const items = r.data.map(item => ({
          ...item,
          cantidad: 1,
          nombrecompleto: `${item.idproduct.nombre} - ${this.GetTipoPreciosFromId(item.idzona)} (S/ ${Number(item.preventa).toFixed(2)}) `,
        }));
        console.log("Items convertidos: ", items);

        this.articulos = items;
      }
    }, e => {
      this.loading = false;
      this.articulos = [];
      console.error(e);
    });
  }

  GetTipoPreciosFromId(idzona: number) {
    // console.log("Obteniendo tipo de precio para zona:", idzona, "tipoprecios:", this.tipoprecios);

    let tipoprecio = this.tipoprecios.find(z => z.idzona == idzona);
    if (tipoprecio && tipoprecio.descripcion) {
      return tipoprecio.descripcion;
    } else {
      return 'N/A';
    }
  }

  // Botón "Agregar" llama a ShowDialogArticulo en tu template; aquí lo usamos para agregar
  ShowDialogArticulo() {
    this.agregarItemSeleccionado();
  }

  agregarItemSeleccionado() {
    const sel = this.selectedArticulo; // sel es el Precio seleccionado (como antes en tu dialog)
    if (!sel) {
      console.log('No hay articulo seleccionado');
      return;
    }

    // Obtener articulo y precio del objeto seleccionado (como en tu lógica original)
    const articulo = (sel as any).idproduct as Articulo;
    const precio = sel as Precio;

    if (!articulo || !precio) {
      console.log('El seleccionado no tiene articulo o precio válido', sel);
      return;
    }

    // Determinar cantidad a agregar (si el precio trae cantidad, úsala; si no, 1)
    const cantidadAgregar = Number((precio as any).cantidad) || 1;

    // Buscar si ya existe un detalle con el mismo idprecio
    const existeIndex = this.detfactus.findIndex((d: DetalleFactura) => {
      // Algunos de tus modelos usan idprecio; si no existe, ajustar la comparación
      return d.idprecio === precio.idprecio;
    });

    if (existeIndex !== -1) {
      // Si existe, sumamos la cantidad y recalculamos ese detalle
      const detExistente: DetalleFactura = this.detfactus[existeIndex];

      const cantidadActual = Number(detExistente.cantidad) || 0;
      const nuevaCantidad = cantidadActual + cantidadAgregar;

      detExistente.cantidad = nuevaCantidad + ""; // lo guardas como string
      // actualizar precio unitario por si acaso (mantener consistencia)
      detExistente.preuni = (Math.round(Number(precio.preventa) * 100) / 100).toFixed(2);
      detExistente.preunict = precio.preventa + "";
      detExistente.idzona = precio.idzona

      // si guardas también el objeto precio/articulo dentro del detalle, actualízalos
      detExistente.precio = precio;
      detExistente.articulo = articulo;

      // recalcular (usa tu función)
      const recalculado = this.calcula_detalle(detExistente);
      // reemplazamos por el recalculado (opcional, dependiendo de tu implementación)
      this.detfactus[existeIndex] = recalculado;

    } else {
      // No existe: crear nuevo DetalleFactura tal como hacías antes
      const det: DetalleFactura = new DetalleFactura();

      // asegurarse de tener factura
      if (!this.factura) {
        this.factura = new Factura(); // o new Factura() según tu modelo
      }

      this.factura.moneda = precio.moneda.simbolo;

      det.n = this.detfactus.length;
      det.articulo = articulo;
      det.idproduct = articulo.idproduct; // según tu estructura
      det.precio = precio;
      det.idprecio = precio.idprecio;
      det.cmoneda = precio.moneda.codigo;
      det.unidad = precio.unidad.unidad;
      det.afectoigv = articulo.afectoigv;
      det.idzona = precio.idzona
      console.log("Idzona escogida: ", precio.idzona);

      det.cantidad = cantidadAgregar + ""; // como string
      det.preuni = (Math.round(Number(precio.preventa) * 100) / 100).toFixed(2);
      det.preunict = precio.preventa + "";

      const detCalculado = this.calcula_detalle(det);
      this.detfactus.push(detCalculado);
    }

    // Recalcular totales y actualizar registro
    this.calcula_total();
    this.actualizar_registro();

    console.log("Factura completa: ", this.factura);
    console.log("lista detalles", this.detfactus);

    // opcional: limpiar la selección en el ng-select
    this.selectedArticulo = null;
  }

  // editar precio desde la tabla
  onPrecioChange(item: any) {
    item.preuni = Number(item.preuni) || 0;
    this.recalcularItem(item);
  }

  // editar cantidad desde la tabla
  onCantidadChange(item: any) {
    item.cantidad = Number(item.cantidad) || 0;
    this.recalcularItem(item);
  }

  recalcularItem(item: any) {
    item.impnetoct = this.round2(item.preuni * item.cantidad);
  }

  // eliminar
  eliminarItem(index: number) {
    if (index < 0 || index >= this.detfactus.length) return;
    this.detfactus.splice(index, 1);
    this.calcula_total();
  }

  // placeholder para la acción de préstamo
  accionPrestamo(item: any, index: number) {
    // Implementa según tu lógica de préstamo
    this.abrirModalPrestamo(item, index);

    // console.log('Prestamo para', item, 'index', index);
  }

  // getter calculado
  get totalItems(): number {
    return this.detfactus.reduce((acc, it) => acc + (Number(it.impnetoct) || 0), 0);
  }

  round2(v: number) {
    return Math.round((v + Number.EPSILON) * 100) / 100;
  }
  openLink(url: string): void {
    this.data.open(url);
  }

  abrirModalPrestamo(item: any, index: number) {
    if (item.articulo.tipo === 'REG') {
      this.data.notify("Los articulos de tipo regalo no pueden marcarse como préstamo", "Aviso", this.data.alertType.error);
      return;
    }

    console.log(item);

    const modalRef = this.modalService.open(SetPrestamoComponent, {
      centered: true,
      size: 'xs',
      windowClass: 'modal-animado',
      backdropClass: 'backdrop-animado'
    });

    // pasar valor inicial
    const val_ini = item.saldo > 0 ? item.saldo : item.ingreso
    modalRef.componentInstance.unidades = val_ini || 0;

    // recibir resultado
    modalRef.result.then((resultado) => {
      // resultado contiene el número de unidades (lo que devolvió activeModal.close())
      console.log('Valor devuelto:', resultado);
      item.saldo = resultado;
      item.ingreso = 0;
      item.isprestamo = true;

      // se comento esto para que se pueda generar la orden de venta
      //item.preuni = 0;
      this.precio_change_precio(index)

      this.data.notify("Se ha marcado como préstamo", "Préstamo", 1);
      // ejemplo: asignarlo a tu pedido
    }).catch((reason) => {
      // cerrado por dismiss (Cancel), aquí puedes ignorar o manejar
      console.log('Modal cerrado/dismiss:', reason);
    });
  }

  ngOnDestroy() {
    this.stopPolling();
    if (this.visibilityHandler) {
      document.removeEventListener('visibilitychange', this.visibilityHandler);
    }
  }

  GetData() {
    console.log(this.usuario);

    const filtro: any = {
      idfactura__idsucursal: this.data.getSucursalId(),
      isprestamo: true,
      tipofecha: 'fecha'
    };

    if (this.usuario.idpersonal.idnivel != 1) {
      filtro.idfactura__idvende = this.usuario.idpersonal.idpersonal;
    }

    this.data.Post('filtrardoc/Detfactu', filtro).subscribe(
      (r) => {
        console.log(r);
        if (r.data) {
          this.detfactus = r.data;
          console.log(this.detfactus);
        } else {
          this.detfactus = [];
        }
      },
      (e) => { console.log(e); this.detfactus = []; }
    );
  }

  // ---- polling simple que actualiza el badge ----
  startPolling(intervalMs: number = 10000) {
    // evita arrancar múltiples subscripciones
    if (this.pollingSub && !this.pollingSub.closed) {
      return;
    }

    const filtro = this.buildFiltro();

    this.pollingSub = timer(0, intervalMs).pipe(
      switchMap(() => this.data.Post('filtrardoc/Factura', filtro))
    ).subscribe(
      (r: any) => {
        if (r && r.data && Array.isArray(r.data)) {

          const dataFiltrada = r.data.filter((item: any) => item.estado !== 'ANU');
          if (dataFiltrada) {
            this.badgeCount = dataFiltrada.length;
            console.log("Cantidad obtenida: ", this.badgeCount);
          } else {
            this.badgeCount = 0;
          }

        } else {
          this.badgeCount = 0;
        }
      },
      (err) => {
        console.error('Error en polling de pendientes', err);
        this.badgeCount = 0;
      }
    );
  }

  stopPolling() {
    if (this.pollingSub) {
      this.pollingSub.unsubscribe();
      this.pollingSub = null;
    }
  }

  // reutiliza la lógica para armar el filtro (igual que en GetData)
  private buildFiltro(): any {
    const filtro: any = {
      fecha: moment(new Date()).format('YYYY-MM-DD'),
      entrega: '0',
      // estado: 'CAN',
      idvende: this.usuario.idpersonal.idnivel != 1 ? this.usuario.idpersonal.idpersonal : null,
      idsucursal: this.data.getSucursalId()
    }
    return filtro;
  }

  ispagocredito() {
    const ventacred = this.detallespago.find(p => p.codigo === '13');
    if (ventacred)
      this.factura.estado = 'EMI'
    else
      this.factura.estado = 'CAN'

    console.log("Estado actual de la factura: ", this.factura.estado);

  }

  GetSaldo(det: DetalleFactura) {
    const detalle = det as any
    const producto = detalle.articulo || detalle.idproduct

    console.log("Info producto de detalle:", producto);
    let saldoActual: number = 0
    if (!producto.idproduct) {
      return
    }
    switch (parseInt(this.data.getSucursalId())) {
      case 1:
        saldoActual = producto.saldo00001;
        break;
      case 2:
        saldoActual = producto.saldo00002;
        break;
      case 3:
        saldoActual = producto.saldo00003;
        break;
      case 4:
        saldoActual = producto.saldo00004;
        break;
      case 5:
        saldoActual = producto.saldo00005;
        break;
      case 6:
        saldoActual = producto.saldo00006;
        break;
      case 7:
        saldoActual = producto.saldo00007;
        break;
      case 8:
        saldoActual = producto.saldo00008;
        break;
      case 9:
        saldoActual = producto.saldo00009;
        break;
      default:
        console.warn(`Sucursal con id  no válida`);
        break;
    }

    console.log("Saldo de detalle:", saldoActual);
    return saldoActual;
  }

  validarSaldo() {
    const flag_cantidad = this.detfactus.find(det =>
      det.esCantidadInvalida
    );
    if (flag_cantidad) {
      this.data.notify(`La cantidad del item ${flag_cantidad.articulo.nombre} no puede ser mayor al stock.`, "Atencion", this.data.alertType.warning)
      this.cantidad_invalida = true
      return flag_cantidad;
    } else {
      this.cantidad_invalida = false
    }
  }

  onTipoBalon1(event: any) {
    const idProducto = parseInt(event.target.value);

    // Buscar el tipo de balón seleccionado
    const tipoSeleccionado = this.tipos_balones.find(t => t.idproduct == idProducto.toString());

    if (tipoSeleccionado) {
      // Guardar solo el ID (integer) para el backend
      this.cliente.tipo_balon = tipoSeleccionado.idproduct;

      // Llamar a onSearch con el nombre para filtrar artículos
      this.onSearchArticulos(tipoSeleccionado.nombre);
    }
  }

  onTipoBalon2(event: any) {
    const idProducto = parseInt(event.target.value);

    const tipoSeleccionado = this.tipos_balones.find(t => t.idproduct == idProducto.toString());

    if (tipoSeleccionado) {
      this.cliente.tipo_balon = tipoSeleccionado.idproduct;

      // Filtrar artículos según el tipo de balón
      this.onSearchArticulos(tipoSeleccionado.nombre);

      // Si ya hay tipo de cliente seleccionado, cargar productos automáticamente
      if (this.cliente.tipo_cliente) {
        this.cargarProductosPorDefecto();
      }
    }
  }

  onTipoBalon(event: any) {
    const idProducto = parseInt(event.target.value);

    const tipoSeleccionado = this.tipos_balones.find(t => t.idproduct == idProducto.toString());

    if (tipoSeleccionado) {
      this.cliente.tipo_balon = tipoSeleccionado.idproduct;

      // ✅ Resetear precio alterno si cambia el tipo de balón
      this.usarPrecioAlterno = false;

      // Filtrar artículos según el tipo de balón
      this.onSearchArticulos(tipoSeleccionado.nombre);

      // Si ya hay tipo de cliente seleccionado, cargar productos automáticamente
      if (this.cliente.tipo_cliente) {
        this.cargarProductosPorDefecto();
      }
    }
  }

  // pedido-index.component.ts

  async cargarProductosPorDefecto1() {
    if (!this.cliente.tipo_balon || !this.cliente.tipo_cliente) {
      console.log("❌ Faltan datos para cargar productos por defecto");
      console.log("   - tipo_balon:", this.cliente.tipo_balon);
      console.log("   - tipo_cliente:", this.cliente.tipo_cliente);
      return;
    }

    console.log("📤 Enviando request:", {
      tipo_balon: this.cliente.tipo_balon,
      tipo_cliente: this.cliente.tipo_cliente
    });

    try {
      const resultado = await this.data.AsyncPost('get_productos_por_defecto', {
        tipo_balon: this.cliente.tipo_balon,
        tipo_cliente: this.cliente.tipo_cliente
      });

      console.log("📥 Respuesta del backend:", resultado);

      if (resultado && resultado.success && resultado.data) {
        this.detfactus = [];

        resultado.data.forEach((producto: any) => {
          console.log("➕ Agregando producto:", producto);
          this.agregarProductoAutomatico(producto);
        });

        // this.data.notify(
        //   `Productos agregados automáticamente (${resultado.data.length} items)`,
        //   "Productos Por Defecto",
        //   this.alertType.success
        // );
      } else {
        console.error("❌ Error en respuesta:", resultado);
        this.data.notify(
          resultado.message || "No se pudieron cargar productos",
          "Error",
          this.alertType.error
        );
      }
    } catch (error) {
      console.error("❌ Error cargando productos por defecto:", error);
      this.data.notify(
        "Error al cargar productos",
        "Error",
        this.alertType.error
      );
    }
  }

  agregarProductoAutomatico(productoData: any) {
    const articulo = productoData.articulo;
    const precio = productoData.precio;
    const cantidad = productoData.cantidad || 1;

    const det: DetalleFactura = new DetalleFactura();

    this.factura.moneda = precio.moneda.simbolo;

    det.n = this.detfactus.length;
    det.articulo = articulo;
    det.idproduct = articulo.idproduct;
    det.precio = precio;
    det.idprecio = precio.idprecio;
    det.cmoneda = precio.moneda.codigo;
    det.unidad = precio.unidad.unidad;
    det.afectoigv = articulo.afectoigv;
    det.idzona = precio.idzona;

    det.cantidad = cantidad + "";
    det.preuni = (Math.round(Number(precio.preventa) * 100) / 100).toFixed(2);
    det.preunict = precio.preventa + "";

    // Si es un plato de regalo, marcarlo como préstamo (precio 0)
    // if (productoData.tipo === 'REG') {
    //   det.isprestamo = true;
    //   det.saldo = cantidad;
    //   det.ingreso = 0;
    // }

    const detCalculado = this.calcula_detalle(det);
    this.detfactus.push(detCalculado);

    this.calcula_total();
    this.actualizar_registro();
  }

  onTipoClienteChange1(event: any) {
    const tipoClienteId = event.target.value;

    console.log("🔍 Tipo de cliente seleccionado:", tipoClienteId);
    console.log("🔍 Tipo de balón actual:", this.cliente.tipo_balon);

    this.cliente.tipo_cliente = tipoClienteId;

    // Si ya hay tipo de balón seleccionado, cargar productos
    if (this.cliente.tipo_balon) {
      this.cargarProductosPorDefecto();
    }
  }

  onTipoClienteChange(event: any) {
    const tipoClienteId = event.target.value;

    console.log("🔍 Tipo de cliente seleccionado:", tipoClienteId);

    this.cliente.tipo_cliente = tipoClienteId;

    // ✅ Resetear precio alterno si cambia el tipo de cliente
    this.usarPrecioAlterno = false;

    // Si ya hay tipo de balón seleccionado, cargar productos
    if (this.cliente.tipo_balon) {
      this.cargarProductosPorDefecto();
    }
  }

  async cargarUltimoPedidoCompleto() {
    if (!this.cliente.idcliente) {
      this.data.notify("Debe seleccionar un cliente primero", "Error", this.alertType.error);
      return;
    }

    try {
      const resultado = await this.data.AsyncPost('get_ultimo_pedido_completo', {
        idcliente: this.cliente.idcliente
      });

      if (resultado && resultado.success && resultado.data.length > 0) {
        // Limpiar productos actuales
        this.detfactus = [];

        // Agregar cada producto del último pedido
        resultado.data.forEach((detalle: any) => {
          this.agregarProductoAutomatico({
            tipo: 'ultimo_pedido',
            articulo: detalle.idproduct,
            precio: detalle.precio,
            cantidad: detalle.cantidad
          });
        });

        this.data.notify(
          `Último pedido cargado (${resultado.data.length} productos)`,
          "Pedido Cargado",
          this.alertType.success
        );
      } else {
        this.data.notify(
          "No se encontró historial de pedidos para este cliente",
          "Sin Historial",
          this.alertType.warning
        );
      }
    } catch (error) {
      console.error("Error cargando último pedido:", error);
      this.data.notify(
        "Error al cargar el último pedido",
        "Error",
        this.alertType.error
      );
    }
  }


  // MÉTODO: Determinar si mostrar botón de precio alterno
  mostrarBotonPrecioAlterno(): boolean {
    // Solo para Domicilio (1) o Negocio (2)
    const tiposPermitidos = [1, 2];

    // Solo para ENVASADO DE 10KG (15)
    const balonesConAlterno = [15];

    return tiposPermitidos.includes(Number(this.cliente.tipo_cliente)) &&
      balonesConAlterno.includes(Number(this.cliente.tipo_balon));
  }

  // MÉTODO: Toggle precio alterno
  togglePrecioAlterno() {
    this.usarPrecioAlterno = !this.usarPrecioAlterno;

    console.log("🔄 Precio alterno:", this.usarPrecioAlterno ? "ACTIVADO" : "DESACTIVADO");

    // Recargar productos con el nuevo precio
    if (this.cliente.tipo_balon && this.cliente.tipo_cliente) {
      this.cargarProductosPorDefecto();
    }
  }

  // ✅ MÉTODO ACTUALIZADO: Cargar productos con flag de precio alterno
  async cargarProductosPorDefecto() {
    if (!this.cliente.tipo_balon || !this.cliente.tipo_cliente) {
      console.log("❌ Faltan datos para cargar productos por defecto");
      return;
    }

    console.log("📤 Cargando productos...", {
      tipo_balon: this.cliente.tipo_balon,
      tipo_cliente: this.cliente.tipo_cliente,
      usar_precio_alterno: this.usarPrecioAlterno
    });

    try {
      const resultado = await this.data.AsyncPost('get_productos_por_defecto', {
        tipo_balon: this.cliente.tipo_balon,
        tipo_cliente: this.cliente.tipo_cliente,
        usar_precio_alterno: this.usarPrecioAlterno  // ✅ NUEVO PARÁMETRO
      });

      console.log("📥 Respuesta del backend:", resultado);

      if (resultado && resultado.success && resultado.data) {
        this.detfactus = [];

        resultado.data.forEach((producto: any) => {
          console.log("➕ Agregando producto:", producto);
          this.agregarProductoAutomatico(producto);
        });

        const tipoPrecio = this.usarPrecioAlterno ? "precio alternativo" : "precio estándar";

        this.data.notify(
          `Productos agregados con ${tipoPrecio}`,
          "Productos Cargados",
          this.alertType.success
        );
      } else {
        console.error("❌ Error en respuesta:", resultado);
        this.data.notify(
          resultado.message || "No se pudieron cargar productos",
          "Error",
          this.alertType.error
        );
      }
    } catch (error) {
      console.error("❌ Error cargando productos:", error);
      this.data.notify(
        "Error al cargar productos",
        "Error",
        this.alertType.error
      );
    }
  }
}
